import React from 'react';
import PropTypes from 'prop-types';
import {Spin as AntdSpin} from 'antd';

// @autobind
/**
 *
 */
export default class Spin extends React.PureComponent {
  static propTypes = {
    size: PropTypes.oneOf([
      'small', 'default', 'large',
    ]),
    spinning: PropTypes.bool,
    tip: PropTypes.string,
    delay: PropTypes.number,
    wrapperClassName: PropTypes.string,
    children: PropTypes.node,
    style: PropTypes.object,
  };

  static defaultProps = {
    size: 'default',
    spinning: true,
    style: {}
  };

  /**
   *
   * @return {XML}
   */
  render() {
    const {size, spinning, tip, delay, wrapperClassName, children, style} = this.props;
    return <AntdSpin {...{size, style, spinning, tip, delay, wrapperClassName, children}} />;
  }
}
